<template>
  <div class="text-xs-center">
    <v-pagination
      v-model="page"
      :length="totalPages"
      :total-visible="7"
      circle
      @input="setPage"></v-pagination>
  </div>
</template>

<script>
  export default {
    props: ['totalPages'],
    methods: {
      setPage() {
        this.$emit('loadPage', this.page)
      },
    },
    data () {
      return {
        page: 1
      }
    }
  }
</script>